import React from 'react';
import { colors } from 'styleguide';

interface Props {
  width?: number;
  height?: number;
  color?: {
    primary: string;
    secondary: string;
  };
}

const Cards = ({
  width = 63,
  color = { primary: '#9498A7', secondary: colors('neutral', 3) },
}: Props) => (
  <svg width={width} viewBox="0 0 63 18" fill="none">
    <rect
      x="0.5"
      y="0.5"
      width="16"
      height="17"
      rx="1.5"
      stroke={color.primary}
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeDasharray="2 4"
    />
    <rect
      x="46.5"
      y="0.5"
      width="16"
      height="17"
      rx="1.5"
      stroke={color.secondary}
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeDasharray="2 4"
    />
    <rect
      x="23.5"
      y="0.5"
      width="16"
      height="17"
      rx="1.5"
      stroke={color.secondary}
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeDasharray="2 4"
    />
  </svg>
);

export default Cards;
